(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["argo-article-section"]) return;
  try {
    
  (function() {
    'use strict';

    var articleBody = document.getElementById('argo-article-body');
    if (!articleBody) return;

    /* =====================================================
       1. Table of Contents Generation
       ===================================================== */
    var headings = articleBody.querySelectorAll('h2, h3');
    var desktopToc = document.getElementById('argo-toc-desktop');
    var mobileTocContainer = document.querySelector('.argo-toc-mobile-dropdown .argo-toc-list');

    if (headings.length > 0 && desktopToc && mobileTocContainer) {
      var tocHtml = '';

      for (var i = 0; i < headings.length; i++) {
        var heading = headings[i];
        var level = heading.tagName === 'H3' ? 3 : 2;

        /* Assign an ID if the heading doesn't have one */
        if (!heading.id) {
          heading.id = 'section-' + i;
        }

        var text = heading.textContent.trim();
        tocHtml += '<li data-level="' + level + '">' +
          '<a href="#' + heading.id + '" data-target="' + heading.id + '">' +
          text + '</a></li>';
      }

      desktopToc.innerHTML = tocHtml;
      mobileTocContainer.innerHTML = tocHtml;
    }

    /* =====================================================
       1b. Read Time Calculation
       ===================================================== */
    var readTimeEl = document.querySelector('.argo-read-time');
    if (readTimeEl && articleBody) {
      var words = articleBody.textContent.trim().split(/\s+/).length;
      var minutes = Math.ceil(words / 225);
      readTimeEl.textContent = minutes + ' min read';
    }

    /* =====================================================
       2. Scroll Spy (IntersectionObserver)
       ===================================================== */
    if (headings.length > 0 && 'IntersectionObserver' in window) {
      var allTocLinks = document.querySelectorAll('.argo-toc-list a[data-target]');

      function setActive(id) {
        for (var j = 0; j < allTocLinks.length; j++) {
          var link = allTocLinks[j];
          if (link.getAttribute('data-target') === id) {
            link.classList.add('argo-toc--active');
          } else {
            link.classList.remove('argo-toc--active');
          }
        }
      }

      var observer = new IntersectionObserver(function(entries) {
        for (var k = 0; k < entries.length; k++) {
          if (entries[k].isIntersecting) {
            setActive(entries[k].target.id);
          }
        }
      }, {
        rootMargin: '-100px 0px -60% 0px',
        threshold: 0
      });

      for (var m = 0; m < headings.length; m++) {
        observer.observe(headings[m]);
      }
    }

    /* =====================================================
       3. Smooth Scrolling for TOC Links
       ===================================================== */
    document.addEventListener('click', function(e) {
      var tocLink = e.target.closest('.argo-toc-list a[data-target]');
      if (!tocLink) return;

      e.preventDefault();
      var targetId = tocLink.getAttribute('data-target');
      var targetEl = document.getElementById(targetId);
      if (!targetEl) return;

      targetEl.scrollIntoView({ behavior: 'smooth' });
      history.pushState(null, '', '#' + targetId);

      /* Auto-close mobile TOC if open */
      var toggle = document.getElementById('argo-toc-toggle');
      var dropdown = document.getElementById('argo-toc-mobile-list');
      if (toggle && toggle.getAttribute('aria-expanded') === 'true') {
        toggle.setAttribute('aria-expanded', 'false');
        dropdown.hidden = true;
      }
    });

    /* =====================================================
       4. Progress Bar
       ===================================================== */
    var progressBar = document.getElementById('argo-progress-bar');
    if (progressBar) {
      var rafTicking = false;

      function updateProgress() {
        var rect = articleBody.getBoundingClientRect();
        var articleTop = rect.top + window.pageYOffset;
        var articleHeight = rect.height;
        var scrolled = window.pageYOffset - articleTop;
        var viewportHeight = window.innerHeight;
        var scrollable = articleHeight - viewportHeight;

        var progress = 0;
        if (scrollable > 0) {
          progress = (scrolled / scrollable) * 100;
          if (progress < 0) progress = 0;
          if (progress > 100) progress = 100;
        } else {
          progress = 100;
        }

        progressBar.style.width = progress + '%';
        rafTicking = false;
      }

      window.addEventListener('scroll', function() {
        if (!rafTicking) {
          requestAnimationFrame(updateProgress);
          rafTicking = true;
        }
      }, { passive: true });

      updateProgress();
    }

    /* =====================================================
       5. Mobile TOC Toggle
       ===================================================== */
    var tocToggle = document.getElementById('argo-toc-toggle');
    var tocDropdown = document.getElementById('argo-toc-mobile-list');

    if (tocToggle && tocDropdown) {
      tocToggle.addEventListener('click', function() {
        var expanded = tocToggle.getAttribute('aria-expanded') === 'true';
        tocToggle.setAttribute('aria-expanded', String(!expanded));
        tocDropdown.hidden = expanded;
      });
    }

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["argo-article"]) return;
  try {
    
  (function() {
    'use strict';

    var articleBody = document.getElementById('argo-article-body');
    if (!articleBody) return;

    /* =====================================================
       1. Table of Contents Generation
       ===================================================== */
    var headings = articleBody.querySelectorAll('h2, h3');
    var desktopToc = document.getElementById('argo-toc-desktop');
    var mobileTocContainer = document.querySelector('.argo-toc-mobile-dropdown .argo-toc-list');

    if (headings.length > 0 && desktopToc && mobileTocContainer) {
      var tocHtml = '';

      for (var i = 0; i < headings.length; i++) {
        var heading = headings[i];
        var level = heading.tagName === 'H3' ? 3 : 2;

        /* Assign an ID if the heading doesn't have one */
        if (!heading.id) {
          heading.id = 'section-' + i;
        }

        var text = heading.textContent.trim();
        tocHtml += '<li data-level="' + level + '">' +
          '<a href="#' + heading.id + '" data-target="' + heading.id + '">' +
          text + '</a></li>';
      }

      desktopToc.innerHTML = tocHtml;
      mobileTocContainer.innerHTML = tocHtml;
    }

    /* =====================================================
       1b. Read Time Calculation
       ===================================================== */
    var readTimeEl = document.querySelector('.argo-read-time');
    if (readTimeEl && articleBody) {
      var words = articleBody.textContent.trim().split(/\s+/).length;
      var minutes = Math.ceil(words / 225);
      readTimeEl.textContent = minutes + ' min read';
    }

    /* =====================================================
       2. Scroll Spy (IntersectionObserver)
       ===================================================== */
    if (headings.length > 0 && 'IntersectionObserver' in window) {
      var allTocLinks = document.querySelectorAll('.argo-toc-list a[data-target]');

      function setActive(id) {
        for (var j = 0; j < allTocLinks.length; j++) {
          var link = allTocLinks[j];
          if (link.getAttribute('data-target') === id) {
            link.classList.add('argo-toc--active');
          } else {
            link.classList.remove('argo-toc--active');
          }
        }
      }

      var observer = new IntersectionObserver(function(entries) {
        for (var k = 0; k < entries.length; k++) {
          if (entries[k].isIntersecting) {
            setActive(entries[k].target.id);
          }
        }
      }, {
        rootMargin: '-100px 0px -60% 0px',
        threshold: 0
      });

      for (var m = 0; m < headings.length; m++) {
        observer.observe(headings[m]);
      }
    }

    /* =====================================================
       3. Smooth Scrolling for TOC Links
       ===================================================== */
    document.addEventListener('click', function(e) {
      var tocLink = e.target.closest('.argo-toc-list a[data-target]');
      if (!tocLink) return;

      e.preventDefault();
      var targetId = tocLink.getAttribute('data-target');
      var targetEl = document.getElementById(targetId);
      if (!targetEl) return;

      targetEl.scrollIntoView({ behavior: 'smooth' });
      history.pushState(null, '', '#' + targetId);

      /* Auto-close mobile TOC if open */
      var toggle = document.getElementById('argo-toc-toggle');
      var dropdown = document.getElementById('argo-toc-mobile-list');
      if (toggle && toggle.getAttribute('aria-expanded') === 'true') {
        toggle.setAttribute('aria-expanded', 'false');
        dropdown.hidden = true;
      }
    });

    /* =====================================================
       4. Progress Bar
       ===================================================== */
    var progressBar = document.getElementById('argo-progress-bar');
    if (progressBar) {
      var rafTicking = false;

      function updateProgress() {
        var rect = articleBody.getBoundingClientRect();
        var articleTop = rect.top + window.pageYOffset;
        var articleHeight = rect.height;
        var scrolled = window.pageYOffset - articleTop;
        var viewportHeight = window.innerHeight;
        var scrollable = articleHeight - viewportHeight;

        var progress = 0;
        if (scrollable > 0) {
          progress = (scrolled / scrollable) * 100;
          if (progress < 0) progress = 0;
          if (progress > 100) progress = 100;
        } else {
          progress = 100;
        }

        progressBar.style.width = progress + '%';
        rafTicking = false;
      }

      window.addEventListener('scroll', function() {
        if (!rafTicking) {
          requestAnimationFrame(updateProgress);
          rafTicking = true;
        }
      }, { passive: true });

      updateProgress();
    }

    /* =====================================================
       5. Mobile TOC Toggle
       ===================================================== */
    var tocToggle = document.getElementById('argo-toc-toggle');
    var tocDropdown = document.getElementById('argo-toc-mobile-list');

    if (tocToggle && tocDropdown) {
      tocToggle.addEventListener('click', function() {
        var expanded = tocToggle.getAttribute('aria-expanded') === 'true';
        tocToggle.setAttribute('aria-expanded', String(!expanded));
        tocDropdown.hidden = expanded;
      });
    }

  })();

  } catch(e) { console.error(e); }
})();
})();
